import { useState } from "react";
import OwnerSidebar from "./OwnerSidebar";
import OwnerHeader from "./OwnerHeader";
import { Outlet } from "react-router-dom";

export default function OwnerLayout() {
  // control sidebar collapse for responsive behavior
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-br from-slate-900 via-slate-950 to-blue-950 lg:flex-row">
      {/* Sidebar */}
      <OwnerSidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />

      {/* Main area */}
      <div className="flex min-w-0 flex-1 flex-col">
        {/* Header */}
        <OwnerHeader onToggleSidebar={() => setCollapsed(!collapsed)} />

        {/* Content */}
        <main className="flex-1 overflow-auto p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
